import React from 'react';
import { SiderParentLabel, SiderItem } from "./";
import { BASE_ROUTES } from 'utils';


export const AdminSide = () => {

    const items = [
        {
            key: 0,
            route: `${BASE_ROUTES.ADMIN_ROUTE}/users`,
            icon: "bi bi-person-circle",
            label: "Agents"
        },
        {
            key: 1,
            route: `${BASE_ROUTES.ADMIN_ROUTE}/skills`,
            icon: "bi bi-bag-check",
            label: "Competences"
        },
        {
            key: 2,
            route: `${BASE_ROUTES.ADMIN_ROUTE}/teams`,
            icon: "bi bi-people-fill",
            label: "Teams"
        },
        {
            key: 3,
            route: `${BASE_ROUTES.ADMIN_ROUTE}/folder-management`,
            icon: "bi bi-folder-fill",
            label: "Folders"
        },
        {
            key: 3,
            route: `${BASE_ROUTES.ADMIN_ROUTE}/tag-management`,
            icon: "bi bi-tag-fill",
            label: "Tags"
        },
    ]

    return (
        <>
            <SiderParentLabel icon="bi bi-gear-wide-connected" label="Admin Part" />
            {items.map(item => <SiderItem {...item} />)}
        </>
    );
}